import Controller from "../../../../core/js/Controller";

export default class NewsList extends Controller {
    constructor() {
        super();

        this.page_size = 12;
        this.offset = this.page_size;
    }

    afterInit() {
        this.button.querySelector('.loader').style.width = this.button.querySelector('span').offsetWidth + 'px';

        if (this.button.dataset.page) {
            this.offset = this.button.dataset.page * this.page_size;
        }
    }

    loadMore(e) {
        e.preventDefault();
        this.toggleButton();

        App.getRequest('/api/news', {
            offset: this.offset,
            tag_id: this.button.dataset.tag_id,
            q: this.button.dataset.q,
            slug: this.button.dataset.slug,
            category_id: this.button.dataset.category_id || 0,
            ct: this.button.dataset.ct
        }).onDone(response => {
            this.container.insertAdjacentHTML('beforeend', response.content);

            if (response.size < this.page_size) {
                this.button.hide();
            } else {
                this.toggleButton();
                this.button.href = response.link;
                this.button.dataset.ct = response.ct;
            }

            this.offset += this.page_size;
        }).onFail(result => {
            this.toggleButton();
        }).execute();
    }

    toggleButton() {
        this.button.toggleDisable();
        this.button.querySelector('span').toggle();
        this.button.querySelector('.loader').toggle();
    }
}